import * as ObjectTypes from '../metadata/objectTypes';
import { DataSourceTypes } from '../schema/data-source';
import { DataSourceTypes as SourceRecordsDataSourceTypes, MetaTypes } from '../schema/source-records';
const allowedObjectTypes = [ObjectTypes.CONTACT, ObjectTypes.COMPANY, ObjectTypes.DEAL, ObjectTypes.TICKET];
export const isTableCompatibleWithSelfAssociations = snowflakeTable => {
  if (!snowflakeTable || !(snowflakeTable.type === DataSourceTypes.HUBSPOT_OBJECT)) {
    return false;
  }
  const {
    dataSourceId,
    metaDefinition = {}
  } = snowflakeTable;
  const {
    metaType
  } = metaDefinition;
  return allowedObjectTypes.includes(dataSourceId) || metaType === MetaTypes.PORTAL_SPECIFIC;
};
export const shouldUseAutoJoin = tableDescription => tableDescription.type !== SourceRecordsDataSourceTypes.HUBSPOT_DATASET && tableDescription.type !== SourceRecordsDataSourceTypes.HUBSPOT_GLOBAL_DATASET;